import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReducer = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 70,
	height: 50,
	viewBox: "0 0 70.0 50.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 70.0 25.0 L 0.0 50.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgReducer;
